// src/components/OrgSwitcher.jsx
import { useState } from 'react';
import {
  Box, Menu, MenuItem, Typography, Chip,
  IconButton, Divider, Tooltip,
} from '@mui/material';
import BusinessIcon     from '@mui/icons-material/Business';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CheckIcon        from '@mui/icons-material/Check';
import { useTranslation } from 'react-i18next';
import { useOrg }  from '../context/OrgContext';
import { useAuth } from '../auth/useAuth';

export default function OrgSwitcher() {
  const { t }               = useTranslation('org');
  const { user }            = useAuth();
  const { org, orgs, orgName, switchOrg } = useOrg();
  const [anchor, setAnchor] = useState(null);

  if (!user?.org_id && !user?.isSuperAdmin) return null;

  const displayName = orgName || t('myOrg');
  const canSwitch   = user?.isSuperAdmin && orgs.length > 1;

  return (
    <>
      <Tooltip title={canSwitch ? t('switchOrg') : displayName}>
        <Box
          onClick={canSwitch ? e => setAnchor(e.currentTarget) : undefined}
          sx={{
            display: 'flex', alignItems: 'center', gap: 0.5,
            px: 1.5, py: 0.5, borderRadius: 20,
            bgcolor: 'rgba(255,255,255,.1)',
            cursor: canSwitch ? 'pointer' : 'default',
            '&:hover': canSwitch ? { bgcolor: 'rgba(255,255,255,.18)' } : {},
            transition: 'background .15s',
          }}
        >
          <BusinessIcon sx={{ fontSize: 15, opacity: .8 }} />
          <Typography fontSize={12} fontWeight={500} noWrap maxWidth={120}>
            {displayName}
          </Typography>
          {canSwitch && <KeyboardArrowDownIcon sx={{ fontSize: 14, opacity: .7 }} />}
        </Box>
      </Tooltip>

      {canSwitch && (
        <Menu
          anchorEl={anchor}
          open={Boolean(anchor)}
          onClose={() => setAnchor(null)}
          PaperProps={{ sx: { minWidth: 220, borderRadius: 2, mt: 1 } }}
        >
          <Box sx={{ px: 2, py: 1.5, borderBottom: '1px solid', borderColor: 'divider' }}>
            <Typography fontSize={11} color="text.secondary" fontWeight={500}>
              {t('switchOrg').toUpperCase()}
            </Typography>
          </Box>
          {orgs.map(o => (
            <MenuItem
              key={o.id}
              onClick={() => { switchOrg(o.id); setAnchor(null); }}
              sx={{ display: 'flex', justifyContent: 'space-between', py: 1 }}
            >
              <Box>
                <Typography fontSize={13} fontWeight={500}>{o.name}</Typography>
                <Typography fontSize={11} color="text.secondary">#{o.id}</Typography>
              </Box>
              {org?.id === o.id && <CheckIcon fontSize="small" color="success" />}
            </MenuItem>
          ))}
        </Menu>
      )}
    </>
  );
}
